module.exports = __webpack_public_path__ + "img/reiki_azul.a4be744e.jpeg";